import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fieldsToShow", "loadingIndicator"]

  static values = {
    providerFieldsUrl: String,
    integrationId: String
  }

  connect() {
    console.log("[integration-form] connect()", {
      providerFieldsUrl: this.providerFieldsUrlValue,
      integrationId: this.integrationIdValue,
      element: this.element
    })

    this.toggleFieldsVisibility()

    requestAnimationFrame(() => {
      const src = this._providerSource()
      console.log("[integration-form] requestAnimationFrame tick — providerSource:", src)
      this.toggleFieldsVisibility()
      this.loadProviderFieldsIfSelected()
    })
  }

  handleProviderChange() {
    const src = this._providerSource()
    console.log("[integration-form] handleProviderChange() — providerSource:", src)
    this.toggleFieldsVisibility()
    this.loadProviderFieldsIfSelected()
  }

  toggleFieldsVisibility() {
    const hasProvider = !!this._providerSource()
    console.log("[integration-form] toggleFieldsVisibility() — hasProvider:", hasProvider)
    this.fieldsToShowTargets.forEach((field) => {
      field.classList.toggle("hidden", !hasProvider)
    })
  }

  loadProviderFieldsIfSelected() {
    const providerSource = this._providerSource()
    console.log("[integration-form] loadProviderFieldsIfSelected() — providerSource:", providerSource, "url:", this.providerFieldsUrlValue)
    if (!providerSource || !this.providerFieldsUrlValue) {
      console.warn("[integration-form] Skipping load — missing providerSource or URL")
      return
    }
    this._loadFrame(providerSource)
  }

  _loadFrame(providerSource) {
    const frame = document.getElementById("integration_provider_fields")
    console.log("[integration-form] _loadFrame() — frame:", frame, "providerSource:", providerSource)
    if (!frame) {
      console.error("[integration-form] turbo-frame#integration_provider_fields not found in DOM!")
      return
    }

    const url = new URL(this.providerFieldsUrlValue, window.location.origin)
    url.searchParams.set("provider_source", providerSource)
    if (this.integrationIdValue) {
      url.searchParams.set("integration_id", this.integrationIdValue)
    }

    console.log("[integration-form] Setting frame.src =", url.toString())
    this._setLoading(true)
    frame.addEventListener("turbo:frame-load", (e) => {
      console.log("[integration-form] turbo:frame-load fired", e)
      this._setLoading(false)
    }, { once: true })
    frame.addEventListener("turbo:frame-missing", (e) => {
      console.error("[integration-form] turbo:frame-missing fired — frame content not found in response", e)
      this._setLoading(false)
    }, { once: true })

    frame.src = url.toString()
  }

  _providerSource() {
    const select = this.element.querySelector("#integration_provider")
    if (!select) {
      console.warn("[integration-form] #integration_provider select not found")
      return ""
    }
    const tsVal = select.tomselect ? select.tomselect.getValue() : null
    const nativeVal = select.value
    const val = tsVal ?? nativeVal
    console.log("[integration-form] _providerSource() — tomselect:", tsVal, "native:", nativeVal, "using:", val)
    return (val && val !== "" && val !== "Select Provider") ? val : ""
  }

  _setLoading(loading) {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.toggle("hidden", !loading)
    }
    const frame = document.getElementById("integration_provider_fields")
    if (frame) frame.style.opacity = loading ? "0.5" : ""
  }
}
